var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_5242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_612_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8596 14.5272C19.9347 14.6228 19.982 14.7382 19.9958 14.8599C20.0096 14.9817 19.9894 15.1049 19.9377 15.2155C19.8859 15.3262 19.8045 15.4197 19.703 15.4854C19.6014 15.5511 19.4837 15.5863 19.3634 15.587H5.28029V18.8478C5.28029 19.0208 5.21284 19.1867 5.09279 19.309C4.97274 19.4313 4.80992 19.5 4.64014 19.5C4.47037 19.5 4.30754 19.4313 4.18749 19.309C4.06744 19.1867 4 19.0208 4 18.8478V5.15217C4 4.97921 4.06744 4.81332 4.18749 4.69102C4.30754 4.56871 4.47037 4.5 4.64014 4.5H19.3634C19.4837 4.50069 19.6014 4.5359 19.703 4.60159C19.8045 4.66728 19.8859 4.7608 19.9377 4.87142C19.9894 4.98204 20.0096 5.10529 19.9958 5.22704C19.982 5.34879 19.9347 5.46411 19.8596 5.55978L16.3388 10.0435L19.8596 14.5272Z",
    fill: "#D30813"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_612_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/priority.606ebf04a790777e7d7a62da14e7e074.svg";
export { ForwardRef as ReactComponent };